import { useEffect, useState, useCallback } from "react";

import Store from "../../../stores/store";
const store = Store.store;

export const useGenerals = () => {
  const [generals, setGenerals] = useState({});
  const [isLoading, setLoading] = useState(true);

  const getGeneralsSummaryReturned = useCallback(() => {
    const _generals = store.getStore("generals");
    setGenerals(_generals);
    setLoading(false);
  }, []);

  useEffect(() => {
    getGeneralsSummaryReturned();

    const watchGeneralsChangeId = setInterval(() => {
      getGeneralsSummaryReturned();
    }, 1000);

    return () => {
      clearInterval(watchGeneralsChangeId);
    };
  }, [getGeneralsSummaryReturned]);

  return { generals, isLoading };
};
